import api from './api.service';
import type {
  Pdf,
  Extraction,
  MonitoringLog,
  MonitoringStats,
  MonitoringCheckResult,
  ProcessPdfResult,
} from '@/types';

export const monitoringService = {
  // Get all PDFs
  async getPdfs(): Promise<Pdf[]> {
    const { data } = await api.get<Pdf[]>('/api/pdfs');
    return data;
  },

  // Get all extractions
  async getExtractions(): Promise<Extraction[]> {
    const { data } = await api.get<Extraction[]>('/api/extractions');
    return data;
  },

  // Get monitoring history
  async getMonitoringHistory(): Promise<MonitoringLog[]> {
    const { data } = await api.get<MonitoringLog[]>('/api/monitoring/history');
    return data;
  },

  // Get monitoring stats
  async getMonitoringStats(): Promise<MonitoringStats> {
    const { data } = await api.get<MonitoringStats>('/api/monitoring/stats');
    return data;
  },

  // Check for updates
  async checkForUpdates(): Promise<MonitoringCheckResult> {
    const { data } = await api.post<MonitoringCheckResult>('/api/monitoring/check');
    return data;
  },

  // Process PDF
  async processPdf(pdfId: number): Promise<ProcessPdfResult> {
    const { data } = await api.post<ProcessPdfResult>(`/api/pdfs/${pdfId}/process`);
    return data;
  },
};

export default monitoringService;
